// extracted by mini-css-extract-plugin
export var alt = "RewardsData-module--alt--ac60c";
export var container = "RewardsData-module--container--de793";
export var desktopOnly = "RewardsData-module--desktopOnly--d3768";
export var main = "RewardsData-module--main--5bae4";
export var mobileOnly = "RewardsData-module--mobileOnly--7974a";
export var styledTable = "RewardsData-module--styledTable--c5131";
export var textLeft = "RewardsData-module--textLeft--e8fb8";
export var visuallyHidden = "RewardsData-module--visuallyHidden--3e08e";